import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=15436aa2&scoped=true&"
import script from "./BookingForm.vue?vue&type=script&lang=js&"
export * from "./BookingForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=15436aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15436aa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15436aa2')) {
      api.createRecord('15436aa2', component.options)
    } else {
      api.reload('15436aa2', component.options)
    }
    module.hot.accept("./BookingForm.vue?vue&type=template&id=15436aa2&scoped=true&", function () {
      api.rerender('15436aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/components/bookings/BookingForm.vue"
export default component.exports